import React from "react";
import Icons from "../../../../Constants/Icons";
import Colors from "../../../../Constants/Colors";
import StatusButton from "../../../../Components/StatusButton/StatusButton";
import moment from "moment";
import CopyToClipboard from "../../../../Components/CopyToClipboard";
import { useNavigate } from "react-router-dom";

function Earningslist({
  ToHide,
  To,
  transactionID,
  from,
  dateTime,
  Amount,
  status,
  data,
  dateTimeSort,
  amountSort,
  fromHide,
  TransactionamountHide,
  TaxamountHide,
  Zigzekmargin,
  activeTab,
  handleScroll,
  commentsContainerRef,
}) {
  const navigate = useNavigate();
  return (
    <div
      style={{
        alignSelf: "stretch",
        flex: 1,
        borderRadius: "8px",
        border: Colors.darkBorderColor,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "1rem",
      }}
    >
      <div
        style={{
          alignSelf: "stretch",
          flex: "1",
          backgroundColor: Colors.borderColor,
          borderBottom: Colors.darkBorderColor,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0.8rem",
        }}
      >
        <div style={{ width: "13%" }} className="contentName">
          {transactionID}
        </div>
        {!fromHide && (
          <div style={{ width: "15%" }} className="contentName">
            {from}
          </div>
        )}
        {!ToHide && (
          <div style={{ width: "15%" }} className="contentName">
            {To}
          </div>
        )}
        <div
          onClick={dateTimeSort}
          style={{
            width: "16%",
            display: "flex",
            cursor: "pointer",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <div
            className="contentName"
            style={{
              fontWeight: "600",
            }}
          >
            {dateTime}
          </div>
          <img
            style={{
              position: "relative",
              width: "1.5rem",
              height: "1.5rem",
              overflow: "hidden",
              flexShrink: "0",
            }}
            alt=""
            src={Icons.ic_shorting}
          />
        </div>
        <div
          onClick={() => amountSort("totalAmount")}
          style={{
            width: "10%",
            display: "flex",
            cursor: "pointer",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <div
            className="contentName"
            style={{
              fontWeight: "600",
            }}
          >
            {!TransactionamountHide && <div>{Amount}</div>}
          </div>
          <img
            style={{
              position: "relative",
              width: "1.5rem",
              height: "1.5rem",
              overflow: "hidden",
              flexShrink: "0",
            }}
            alt=""
            src={Icons.ic_shorting}
          />
        </div>

        <div
          onClick={() => amountSort("zigzakMargin")}
          style={{
            width: "10%",
            display: "flex",
            cursor: "pointer",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <div
            className="contentName"
            style={{
              fontWeight: "600",
            }}
          >
            {!TaxamountHide && <div>{Zigzekmargin}</div>}
          </div>
          <img
            style={{
              position: "relative",
              width: "1.5rem",
              height: "1.5rem",
              overflow: "hidden",
              flexShrink: "0",
            }}
            alt=""
            src={Icons.ic_shorting}
          />
        </div>

        <div style={{ width: "10%" }} className="contentName">
          {status}
        </div>
      </div>

      <div
        // style={{ maxHeight: "75vh" }}
        style={{ maxHeight: "calc(100vh - 14.7vh)" }}
        onScroll={handleScroll}
        ref={commentsContainerRef}
        className="scrollable-container"
      >
        {data.map((item, index) => (
          <div key={index}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                flex: 1,
                borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
                padding: "0.8rem",
                alignSelf: "stretch",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  width: "13%",
                  wordBreak: "break-all",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "0.5rem",
                    alignSelf: "stretch",
                  }}
                >
                  <div className="fontSize18Weight400">{item._id}</div>
                  <CopyToClipboard text={item._id}>
                    <img
                      style={{
                        cursor: "pointer",
                      }}
                      className="icon_copy"
                      alt=""
                      src={Icons.ic_copy}
                    />
                  </CopyToClipboard>
                </div>
              </div>

              <div
                style={{
                  width: "15%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  gap: "0.5rem",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate("/UserProfile", {
                    state: {
                      userId: item.userId,
                      userShortId: item.userId,
                    },
                  });
                }}
              >
                <div style={{}} className="indian-man-smiling-astrologer">
                  <img
                    style={{
                      position: "relative",
                      width: "2.63rem",
                      height: "2.63rem",
                    }}
                    alt=""
                    src={item.userImage ?? Icons.ic_default_user}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                  }}
                >
                  <div className="fontSize18Weight400">{item.userName}</div>
                </div>
              </div>
              <div
                style={{
                  width: "15%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  gap: "0.5rem",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate("/AstrologerProfile", {
                    state: {
                      astrologerId: item.astrologerId,
                    },
                  });
                }}
              >
                <div style={{}} className="indian-man-smiling-astrologer">
                  <img
                    style={{
                      position: "relative",
                      width: "2.63rem",
                      height: "2.63rem",
                    }}
                    alt=""
                    src={activeTab == 0 ? item?.astrologerImage : item.appImage}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                  }}
                >
                  <div className="fontSize18Weight400">
                    {activeTab == 0 ? item?.astrologerName : item.appName}
                  </div>
                  <div
                    style={{ color: Colors.secondary }}
                    className="fontSize18Weight400"
                  >
                    {activeTab == 0
                      ? item?.astrologerRole
                      : item.appTransaction}
                  </div>
                </div>
              </div>

              <div
                style={{
                  width: "16%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >
                <div className="fontSize18Weight400">
                  {moment(item?.date_and_time).format("DD-MM-YYYY")}
                  {", " + moment(item?.date_and_time).format("hh:mm a")}
                </div>
              </div>
              <div
                style={{
                  width: "10%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >
                <div className="fontSize18Weight400">
                  {"₹" + item.totalAmount}
                </div>
              </div>
              <div
                style={{
                  width: "10%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >
                <div className="fontSize18Weight400">
                  {"₹" + item.zigzakMargin}
                </div>
              </div>

              <StatusButton
                style={{
                  width: "10%",
                  backgroundColor:
                    item.status === "successful"
                      ? Colors.mainGreen01
                      : item.status === "failed"
                      ? Colors.mainRed01
                      : Colors.mainOrange01,
                  borderColor:
                    item.status === "successful"
                      ? Colors.darkGreen
                      : item.status === "failed"
                      ? Colors.darkRed
                      : Colors.darkOrange,
                  color:
                    item.status === "successful"
                      ? Colors.darkGreen
                      : item.status === "failed"
                      ? Colors.darkRed
                      : Colors.darkOrange,
                }}
              >
                {item.status}
              </StatusButton>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Earningslist;
